import React, {Component} from 'react';
import Modal from 'react-modal';
import KeyboardedInput from 'react-touch-screen-keyboard';
import PropTypes from 'prop-types'
import {translate} from 'i18n/i18n';
import {inject, observer} from 'mobx-react';
import FormValidator from 'store/validators/FormValidator';

@translate()
@inject('store')
@observer
class ShopHackTextInputModal extends Component {
    constructor() {
        super();
        this.state = {
            open: false,
            inputValue: '',
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.triggerOpen && !prevProps.triggerOpen) {
            const initialValue = this.props.moduleStore.products[Number(this.props.formFieldName)].quantity;
            this.setState({
                open: true,
                inputValue: initialValue || ''
            });
        }
    }

    closeModal() {
        this.setState({open: false});
    }

    initialFocus(ref) {
        const {open} = this.state;
        if (open) {
            if (!this.inputRef && ref) {
                ref.focus();
            }
        }

        this.inputRef = ref;
    }

    isNewValueValid(newValue) {
        const {isNumber} = this.props;
        const validator = new FormValidator();

        if (isNumber) {
            return validator.isValidNumberForChange(newValue);
        }

        return true;
    }

    getKeyboardLayoutByType() {
        const {isNumber} = this.props;

        if (isNumber) {
            return numberKeyboardLayout;
        }

        return keyboardLayout;
    }

    render() {
        const {
            t, setTitle, formFieldName, moduleStore, onSave,
            closeOnOutClick,  isNumber, isAlwaysUppercase, redInputBorder
        } = this.props;
        const {open} = this.state;
        // Value is now managed in local state
        const onChange = (newValue) => {
            console.log('onChange called with:', newValue, 'for field:', formFieldName);
            if (this.isNewValueValid(newValue)) {
                if (newValue === '') {
                    newValue = '';
                }

                if (isAlwaysUppercase && newValue) {
                    newValue = newValue.toUpperCase();
                }

                console.log('Updating local input value to:', newValue);
                this.setState({ inputValue: newValue });
            }
        };

        const save = () => {
            this.inputRef = null;
            console.log('Saving input value:', this.state.inputValue, 'to store for field:', formFieldName);
            moduleStore.setFormValue(formFieldName, this.state.inputValue);
            if (onSave) {
                onSave();
            }
            if (this.props.onClose) {
                this.props.onClose();
            }
            this.closeModal();
        };

        const close = () => {
            this.inputRef = null;
            this.closeModal();
        };

        const keyboard = this.getKeyboardLayoutByType();

        return (
            <Modal isOpen={open} onRequestClose={close} shouldCloseOnOverlayClick={closeOnOutClick}
                   className="form-modal">
                <div className="input-modal-container">
                    <div className="modal-message-text">{setTitle}</div>

                    <label htmlFor="inp"
                           className={`inp center modal-search-keyboard 
                           ${( isNumber) && 'float-input'} ${redInputBorder ? 'red-input-border' : ''}`}>
                        <KeyboardedInput enabled
                                         ref={ref => this.initialFocus(ref)}
                                         onBlur={() => {
                                             if (this.inputRef) {
                                                 this.inputRef.focus()
                                             }
                                         }}
                                         onChange={onChange}
                                         value={this.state.inputValue}
                                         isDraggable={false}
                                         defaultKeyboard={keyboard}
                                         isFirstLetterUppercase={false}/>
                    </label>
                    <div style={{display: 'flex', justifyContent: 'space-evenly', width: '100%'}}>

                        <button
                            type="button"
                            className="input-modal-save btn btn-light"
                            onClick={save}

                        >
                            {t('COMMON.SAVE')}
                        </button>
                    </div>

                </div>
            </Modal>
        )
    }
}

ShopHackTextInputModal.propTypes = {
    setTitle: PropTypes.string.isRequired,
    moduleStore: PropTypes.any.isRequired,
    formFieldName: PropTypes.string.isRequired,
    closeOnOutClick: PropTypes.any,
    triggerOpen: PropTypes.any,
    isEmail: PropTypes.any,
    isNumber: PropTypes.any,
    onSave: PropTypes.any,
    onClose: PropTypes.any,
    isAlwaysUppercase: PropTypes.bool,
    redInputBorder: PropTypes.bool,
    actCodeWarning: PropTypes.bool,
    value: PropTypes.any,
};


const numberKeyboardLayout = [
    ['7', '8', '9'],
    ['4', '5', '6'],
    ['1', '2', '3'],
    ['*bs', '0', '.'],
];

const keyboardLayout = [
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'å'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'æ', 'ø'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm', '.', '@', '*sh']
];

export default ShopHackTextInputModal;
